export class Populations {
  public static Default = 'Default';
  public static Employees = 'Employees';
  public static Guardian = 'Guardian';
  public static Kids = 'Kids';
}
